// extracted by mini-css-extract-plugin
export var deleteModal = "_sa-0";